{
  "email": "Email",
  "emailAddress": "E-mail address",
  "phoneNumber": "Phone number",
  "login": "Login",
  "back": "Back",
  "goBack": "Go back",
  "continue": "Continue",
  "proceed": "Proceed",
  "date": "Date",
  "error": "An error occurred",
  "noData": "No data available",
  "welcome": "Welcome back",
  "delete": "Delete",
  "detach": "Detach",
  "featureUnavailable": "This feature is currently unavailable",
  "bulkEdit": "Bulk edit",
  "bulkEditModal": {
    "description": "Only the fields you update will be changed. Completing all fields is not required.",
    "selectFields": {
      "title": "Select fields you want to edit",
      "subtitle": "Any previously selected values will be replaced with your choice"
    },
    "fieldPlaceholder": "Select to update"
  },
  "feedback": "Feedback",
  "loading": "Loading",
  "contactUs": "Contact Us",
  "pleaseRefresh": "Please refresh the page or try again later.",
  "comingSoon": "Coming soon",
  "failedStorageConnection": "Upload is currently unavailable. Issues may be caused by network, VPN, or system configuration",
  "dragAndDrop": "Drag & drop or browse files (pdf, doc, docx, jpg, png, xls, xlsx, pptx, ppt, csv, txt)",
  "clickToSeeMoreDetails": "Click to see more details",
  "details": "Details",
  "showDetails": "Show details",
  "hideDetails": "Hide details",
  "noDescriptionAvailable": "No description is available",
  "about": "About",
  "search": "Search",
  "cancel": "Cancel",
  "ok": "Ok",
  "submit": "Submit",
  "confirm": "Confirm",
  "clear": "Clear",
  "apply": "Apply",
  "close": "Close",
  "undo": "Undo",
  "from": "From",
  "to": "To",
  "attach": "Attach",
  "unassigned": "Unassigned",
  "myself": "Myself",
  "current": "Current",
  "copy": "Copy",
  "copyToClipboard": "Copied to clipboard",
  "copyToClipboardTooltip": "Click to copy {{text}}",
  "partOfTotal": "{{part}} of {{total}}",
  "selectedRows_one": "{{count}} row selected",
  "selectedRows_other": "{{count}} rows selected",
  "selectAll": "Select All",
  "selectedCount": "{{count}} selected",
  "appliedFilters": "Applied filters ({{count}})",
  "clearAllFilters": "clear all filters",
  "appName": "SpendBrain",
  "extensionAppName": "Sidecar",
  "selectDate": "Select date",
  "askSpendBrain": "Ask SpendBrain",
  "addSelected": "Add selected ({{count}})",
  "download": {
    "title": "Download",
    "unavailable": "Download unavailable",
    "downloading": "Downloading...",
    "error": "Download Failed"
  },
  "preview": {
    "title": "Preview",
    "unavailable": "Preview unavailable"
  },
  "dataView": {
    "tabular": "Tabular view",
    "kanban": "Kanban board"
  },
  "timeUnits": {
    "minutes": "minutes"
  },
  "clamp": {
    "showMore": "show more",
    "showLess": "show less"
  },
  "view": "View",
  "viewAll": "View all",
  "success": "Success",
  "failure": "Failure",
  "contactData": {
    "email": "Email",
    "emailAddress": "E-mail address",
    "phone": "Phone",
    "phoneNumber": "Phone number"
  },
  "pinning": {
    "toLeft": "Pin to left",
    "toRight": "Pin to right",
    "unpin": "Unpin"
  },
  "entity": {
    "ticketComment": "Ticket comment",
    "taskComment": "Task comment",
    "files": "files",
    "vendors": "vendors",
    "locations": "locations",
    "organizations": "organizations",
    "subsidiaryOrganizations": "subsidiary-organizations",
    "vendorAccounts": "vendor-accounts",
    "documents": "documents",
    "invoices": "invoices",
    "tickets": "tickets",
    "tasks": "tasks",
    "recurringTasks": "recurring-tasks",
    "actionItems": "action-items",
    "contacts": "contacts",
    "contracts": "contracts",
    "sibContracts": "sib-contracts",
    "audits": "audits",
    "negotiationSpendItems": "negotiation-spend-items"
  },
  "filters": {
    "title": "Filters",
    "selectPlaceholder": "Select",
    "searchPlaceholder": "Type something...",
    "clear": "Clear filters",
    "apply": "Apply",
    "search": "Search"
  },
  "types": {
    "all": "All",
    "contracts": "Contracts",
    "invoices": "Invoices",
    "siteLists": "Location Lists",
    "other": "Other",
    "letterOfAuthorization": "LoA"
  },
  "sidebar": {
    "dashboard": "Dashboard",
    "work": "Work",
    "projects": "Projects",
    "team": "Team",
    "savingsAndSpendAnalysis": "Savings",
    "organizations": "Organizations",
    "services": "Services",
    "documents": "Documents Repository",
    "locations": "List of locations",
    "reports": "Reports",
    "upcomingEvents": "Upcoming Events",
    "chat": "Chat",
    "teamMembers": "Team Members",
    "account": "Account",
    "billings": "Billing",
    "vendors": "Vendors",
    "revenue": "Revenue",
    "about": "About SIB",
    "sendFeedback": "Send Feedback",
    "subsidiaryOrganization": "Subsidiary Organization",
    "tickets": "Your Tickets",
    "help": "Help",
    "billPay": "Bill Pay",
    "contractTerms": "Contract Terms Library",
    "storybook": "Storybook"
  },
  "emptyPagePlaceholder": {
    "title": "We are working on it!",
    "description": "The module you selected is currently unavailable. We are working on the development of the application and plan to add more features in the future. Thank you for your patience, and we encourage you to follow the 'About SIB' page, where we will keep you updated on the ongoing development of the SpendBrain application."
  },
  "notifications": {
    "create": {
      "success": "{{entity}} created successfully",
      "failure": "{{entity}} creation failed"
    },
    "edit": {
      "success": "{{entity}} edited successfully",
      "failure": "{{entity}} edit failed"
    },
    "update": {
      "success": "{{entity}} updated successfully",
      "failure": "{{entity}} update failed"
    },
    "delete": {
      "success": "{{entity}} deleted successfully",
      "failure": "{{entity}} deletion failed"
    },
    "clone": {
      "success": "{{entity}} cloned successfully",
      "failure": "{{entity}} clone failed"
    }
  },
  "share": "Share",
  "customize": "Customize",
  "export": "Export",
  "upload": "Upload",
  "saveAndUpload": "Save & Upload",
  "downloadSelected": "Download ({{count}}) selected",
  "incorrect": "Incorrect",
  "more": "More",
  "add": "Add",
  "include": "Include",
  "remove": "Remove",
  "new": "New",
  "create": "Create",
  "update": "Update",
  "noResults": "No results found",
  "active": "Active",
  "inactive": "Inactive",
  "offboarded": "Offboarded",
  "notSelected": "Not selected",
  "for": "For",
  "completed": "Completed",
  "uncompleted": "Uncompleted",
  "all": "All",
  "myEntity": "My {{entity}}",
  "select": "Select",
  "typePlaceholder": "Type...",
  "none": "None",
  "required": "Required",
  "optional": "Optional",
  "replace": "Replace",
  "edit": "Edit",
  "clone": "Clone",
  "save": "Save",
  "approve": "Approve",
  "sortBy": "Sort by:",
  "lastEdited": "Last edited",
  "lastUpdated": "Last updated",
  "created": "Created",
  "assigne": "Assigne",
  "deactivated": "Deactivated",
  "userDeactivated": "User deactivated",
  "calendarTopLabel": "Select time",
  "noTimeSelected": "No time selected",
  "noDateSelected": "No date selected",
  "emptyListMessageWithSearch": "There are no results for the phrase you are looking for. Please use another phrase and try again",
  "time": {
    "min": "min",
    "minutes_one": "{{count}} minute",
    "minutes_other": "{{count}} minutes"
  },
  "noFilteredResults": {
    "title": "No results found",
    "description": "No results to display, try adjusting the filters to find relevant results."
  },
  "yes": "Yes",
  "no": "No",
  "pay": "Pay",
  "files_one": "{{count}} file",
  "files_other": "{{count}} files",
  "loginPage": {
    "title": "Welcome to your {{appName}}",
    "description": "Sign in to access your dashboard",
    "buttonBaseText": "Sign in",
    "buttonLoadingText": "Signing in...",
    "infoMessage": "Don't close this window during sign in process.",
    "termsOfUseHint": "By signing in, you agree to our <termsLink>Terms Of Use</termsLink> and <privacyLink>Privacy Policy</privacyLink>"
  },
  "auth": {
    "unexpectedError": "An unexpected error occurred"
  },
  "dropzone": {
    "title": "Drag & drop",
    "subtitle": "upload files by dropping them in this window",
    "text": "format: pdf, doc, docx, jpg, xlsx, pptx, ppt, csv, txt"
  },
  "uploadDocuments": {
    "title": "Upload documents",
    "description": "Supported format: {{formats}}",
    "browse": "Browse",
    "dragAndDrop": "drag & drop or",
    "maxFilesNumber": " Max documents number: {{number}}",
    "maxFilesSize": "Max size of documents: {{size}}MB"
  },
  "avatarUpload": {
    "successMessage": "Avatar uploaded successfully",
    "errorMessage": "Failed to upload avatar. Please try again later."
  },
  "activateSpendArea": {
    "successMessage_one": "You've successfully activated {{area}} spend area",
    "successMessage_other": "You've successfully activated {{count}} spend areas",
    "errorMessage_one": "Failed to activate {{area}} spend area. Please try again later.",
    "errorMessage_other": "Failed to activate {{count}} spend areas. Please try again later."
  },
  "fileManager": {
    "drag": "Drag & drop or browse files",
    "dragDrop": "Drag & drop",
    "dropfiles": "upload {{entityName}} by dropping them in this window ",
    "supported": "Supported format: {{formats}}",
    "maxFileSize": "Maximum file size: {{size}}",
    "browser": "Browse files manually",
    "transfer": "Files to be uploaded:",
    "files": "files",
    "invalidFormat": "File format is invalid",
    "sizeExceedsLimit": "File size exceeds the {{limit}} limit",
    "uploadFiles": "Upload files",
    "uploadingFiles_one": "{{count}} file uploading",
    "uploadingFiles_other": "{{count}} files uploading",
    "uploadFilesForOrganization": "Upload files for {{name}}",
    "uploadFailedMessage": "File upload failed, try again later",
    "uploadCancelledMessage": "Upload cancelled",
    "uploadFailedPartialDescription": "You've successfully uploaded {{uploadedCount}} file(s), but {{failedCount}} file(s) failed to upload.",
    "uploadFailedAllFailedDescription": "{{failedCount}} file(s) failed to upload.",
    "uploadSuccess": {
      "message": "File Upload Successful",
      "description": "You've successfully uploaded {{uploadedCount}} file(s).",
      "redirectToDocumentsRepository": "Go to documents repository"
    },
    "startUploadMessage": "Your files are being uploaded",
    "startUploadDescription": "You can track the progress of your upload in the 'Upload files' section.",
    "uploadPhases": {
      "processing": "Processing...",
      "waiting": "Waiting...",
      "uploading": "Uploading...",
      "complete": "Complete"
    },
    "markAsSensitive": {
      "title": "Mark as sensitive",
      "singleMarkTooltip": {
        "mark": "Click to mark as sensitive data. It will be visible to admin users only.",
        "unMark": "Click to remove sensitive status. It will be visible to all users."
      },
      "multiMarkTooltip": "Select one or more file to mark as sensitive data. It will be visible to admin users only."
    },
    "internalDocuments": {
      "uploadBanner": "Documents uploaded here are internal-only by default and hidden from the client's SpendBrain. After upload, open the document in the list and choose \"Show client\" from the row menu or edit dialog."
    },
    "fileActions": {
      "new": "New file",
      "restoring": "File deleted"
    },
    "actions": {
      "checkUploadStatus": {
        "error": {
          "message": "Failed to update upload status",
          "description": "An error occurred while checking the upload status. Please try again later."
        }
      }
    },
    "tooltips": {
      "uploadDisabledContactSupport": "File upload is currently disabled. Please contact support for assistance.",
      "uploadDisabledNoOrganization": "File upload is disabled because no organization is selected."
    }
  },
  "components": {
    "storageConnection": {
      "title": "Oops! No internet connection / storage",
      "description": "Sorry, there's been poor network connection detected. Please check your connectivity and then try to upload your files. If the issue persists, check your network, VPN, or computer configuration."
    },
    "topbar": {
      "enterFullscreen": "Fullscreen Mode",
      "exitFullscreen": "Exit Fullscreen",
      "searchPlaceholder": "Search...",
      "search": {
        "minLength": "Type at least {{count}} characters to search",
        "loading": "Searching...",
        "emptyForPhrase": "No search results found for the \"{{searchTerm}}\" phrase",
        "error": "Something went wrong. Please try again.",
        "previousSearches": "Previous search:",
        "noPreviousSearches": "No previous search results",
        "moduleSection": "{{module}} ({{count}}):",
        "moduleTab": "{{module}} ({{count}})",
        "modules": {
          "all": "All",
          "organizations": "Organizations",
          "vendors": "Vendors",
          "audits": "Audits",
          "tasks": "Tasks",
          "projects": "Projects"
        }
      }
    },
    "workInProgress": {
      "title": "Work in progress",
      "description": "This product is currently under active development. Some features may not work as expected and functionality may change as improvements are released."
    },
    "userMenu": {},
    "hero": {
      "title": "LET'S START THE CONVERSATION WITH YOUR SPEND",
      "description": "Ask SpendBrain anything about your spending, potential savings, or errors in any and all of your accounts."
    },
    "dataTable": {
      "emptyFilter": {
        "apply": "Show empty only",
        "clear": "Show all",
        "optionLabel": "(Empty only)"
      },
      "filterPlaceholder": "Values",
      "loading": "We're making sure everything is accurate. This may take a little longer...",
      "columnVisibilitySettings": {
        "title": "Displaying columns",
        "subtitle": "Here you can manage which columns / data are being displayed on your list",
        "save": "Save",
        "selectedCount": "{{selected}} / {{total}} selected"
      },
      "dataTableSettingsDialog": {
        "resetColumnOrder": "Set up the columns back to default order"
      }
    },
    "filePreview": {
      "goBack": "Go back to documents repository",
      "loading": "Loading document...",
      "unsupportedDescription": "This file format cannot be previewed. Please download to view the content.",
      "error": {
        "title": "Failed to load document",
        "message": "An error occurred while loading the preview document. Try downloading the document or try again later."
      },
      "unsupported": {
        "title": "Preview not available",
        "description": "This file format cannot be previewed. Please download to view the content."
      }
    },
    "csvPreview": {
      "searchPlaceholder": "Search CSV...",
      "rows": "{{filtered}} of {{total}} rows",
      "columns": "{{count}} columns",
      "emptyHeader": "Column {{index}}",
      "noResults": "No matching rows",
      "error": {
        "title": "Unable to load CSV",
        "message": "There was an error loading the CSV file. Try downloading the document or try again later."
      }
    },
    "autocomplete": {
      "notSelected": "Not selected",
      "searchPlaceholder": "Search"
    },
    "errorBoundary": {
      "reset": "Refresh",
      "title": "Something went wrong!",
      "defaultMessage": "Please refresh the page and try again."
    },
    "tablePagination": {
      "partOfTotal": "{{part}} <highlight>of</highlight> {{total}}",
      "partOfTotalSimple": "{{part}} of {{total}}",
      "itemsPerPage": "Items per page",
      "itemsPerPageWithColon": "Items per page:"
    },
    "tasksTable": {
      "columns": {
        "completed": "Completed",
        "title": "Title",
        "description": "Description",
        "category": "Category",
        "assignee": "Assignee",
        "createdBy": "Created By",
        "status": "Status",
        "dueDate": "Due Date",
        "priority": "Priority",
        "lastUpdated": "Last Updated",
        "deadline": "Deadline",
        "estimatedTime": "Est. Time",
        "organization": "Organization",
        "files": "Files",
        "comments": "Comments"
      },
      "noData": {
        "withoutFilters": {
          "title": "No tasks found",
          "description": "Create a task to get started"
        },
        "withFilters": {
          "title": "No tasks match your filters",
          "description": "Try adjusting your filters to find what you're looking for"
        }
      }
    },
    "table": {
      "filter": {
        "comingSoon": "This feature will be available soon."
      }
    },
    "confirmationDialog": {
      "defaultTitle": "Are you sure you want to perform this action?"
    },
    "defaultLayout": {
      "logOutConfirmation": "Are you sure you want to log out?"
    },
    "userSpendAreas": {
      "title": "Your spend areas",
      "annualSavings": "Annual savings for this spend area",
      "savingsIdentified": "Savings identified",
      "savingsApproved": "Savings approved",
      "noData": {
        "title": "No active Spend Areas",
        "description": "There are currently no active spend areas. Activate them to analyze savings within their scope.",
        "titleSteps": "No active Action Items",
        "descriptionSteps": "There are currently no active action items. New items will appear here as soon as they are assigned."
      },
      "error": "Failed to load action items",
      "learnMore": "learn more about stages",
      "inProgress": "In progress",
      "preparingOffer": "we are preparing an offer",
      "spendAreas": "You have {{count}} spend areas in this stage",
      "noSpendAreas": "No spend areas in this stage",
      "show": "show",
      "less": "less",
      "nextSteps_one": "Action Item",
      "nextSteps_other": "Action Items ({{count}})",
      "nextStepsWithActive_one": "Action Item",
      "nextStepsWithActive_other": "Action Items ({{active}}/{{count}})",
      "noSteps": "No action items are available",
      "details": {
        "yourSavings": "Your savings",
        "inStages": "In stages",
        "invoicesUploadedOn": "Invoices uploaded on",
        "spendAreaAssignedToLocations": "Spend area assigned to {{count}} of {{max}} locations",
        "checkSavings": "Check savings",
        "addMore": "Add more"
      },
      "sendEmailTooltip": "Click to send an e-mail to {{email}} regarding the issue",
      "delayedByDays_one": "Delayed by {{count}} day",
      "delayedByDays_other": "Delayed by {{count}} days",
      "dueDateTooltip": "Due date",
      "scheduleMeetingTooltip": "Schedule a meeting",
      "downloadContractTooltip": "Download contract",
      "openLinkTooltip": "Open link",
      "assignedToStageTooltip": "Applies to: {{stage}}",
      "completed": "Completed",
      "completedTooltip": "This action item is completed"
    },
    "spendAreas": {
      "title": "Industry peers also saved on...",
      "button": "Activate {{count}} spend areas",
      "dialogTitle": "We're preparing an expanded offer",
      "dialogSubtitle": " We are preparing an expanded offer including the spend categories you selected. We will contact you within the next few business days.",
      "selectArea": "Select area to activate",
      "buttonTooltip": "Select one or more areas by clicking + and activate them. We'll prepare an offer of expanded plan.",
      "seeMoreSpend": "See more available spend areas",
      "seeMore": "see more",
      "addNewSpend": "Add new spend areas to your plan and save even more!",
      "selectedArea_one": "Selected area:",
      "selectedArea_other": "Selected areas:",
      "cancel": "Not now",
      "confirm": "Continue activation",
      "activate": "Activate",
      "activateTooltip": "We'll prepare a proposition of expanded offer including this spend area",
      "fact": "Other peers from your industry saved up to 80%!",
      "about": "About",
      "noData": {
        "title": "No other Spend Areas",
        "description": "At the moment, there are no other available spend areas. Please check back later for any updates or new options."
      },
      "error": {
        "title": "Failed downloading other Spend Areas"
      }
    },
    "organizationSwitchDialog": {
      "switch": "Organization switch",
      "title": "Select organization",
      "selectedAccount": "Selected organization",
      "successMessage": "You've successfully switched organization from {{organization}} to {{newOrganization}}",
      "noResults": "No results matching search criteria"
    },
    "uploadQueueGuardDialog": {
      "title": "Some files are uploading",
      "successTitle": "Files uploaded",
      "successDescription": "Your files were uploaded successfully. You can switch organizations now.",
      "description_one": "{{count}} file for this organization is still being uploaded.\nSwitching organizations now will interrupt the upload and cause you to lose progress.\nAre you sure you want to switch organizations?",
      "description_other": "{{count}} files for this organization are still being uploaded.\nSwitching organizations now will interrupt the upload and cause you to lose progress.\nAre you sure you want to switch organizations?",
      "errorLine_one": "{{count}} file failed to upload.",
      "errorLine_other": "{{count}} files failed to upload.",
      "confirm": "Switch organization",
      "successConfirm": "Close and switch organization",
      "openFileManager": "Open file manager"
    },
    "organizationSwitchButton": {
      "parent": "Parent Organization",
      "subsidiary": "Subsidiary Organization",
      "parentShort": "P.Org",
      "subsidiaryShort": "S.Org"
    },
    "organizationSwitch": {
      "title": "Switch Organizations"
    },
    "selectFilter": {
      "selectStatus": "Select status",
      "selected": "({{count}}) selected",
      "clearAll": "Clear all"
    },
    "numberRangeFilter": {
      "selectRange": "Select range <muted>{{unit}}</muted>",
      "selectRangeType": "Select range type <muted>{{unit}}</muted>",
      "operators": {
        "between": "Between",
        "nbetween": "Not between",
        "eq": "Equal to",
        "lt": "Less than",
        "lte": "Less than or equal to",
        "gt": "Greater than",
        "gte": "Greater than or equal to"
      }
    },
    "spendAreasListItem": {
      "alreadyOptimized": "already optimized"
    },
    "shareDialog": {
      "title": "Share access to SpendBrain",
      "subtitle": "Build better collaboration with people from your organization",
      "shareUnavailable": "Share is currently unavailable. Please try again later or contact the administrator.",
      "invited": "{{count}} Invited",
      "invite": "Invite",
      "resend": "Resend",
      "remove": "Remove",
      "noData": "You haven't shared access with any members yet",
      "fieldPlaceholder": "Type e-mail address...",
      "loggedInCount": "{{count}} logged in",
      "loggedInTooltip_one": "{{count}} user has logged in",
      "loggedInTooltip_other": "{{count}} users have logged in",
      "noLoggedInUsers": "None of invited user has logged in",
      "emailCopied": "E-mail address copied",
      "tooltips": {
        "userLoggedIn": "User has logged in",
        "userNotLoggedIn": "User hasn't logged in yet",
        "clickToCopy": "Click to copy e-mail address",
        "resendInvitation": "Resend the invitation e-mail",
        "resendInvitationDisabled": "Users who have already logged in cannot be resent invitation. Please contact our team member to resend this user's invitation to SpendBrain.",
        "removeAccess": "Remove access to SpendBrain",
        "removeAccessDisabled": "Users who have already logged in cannot be removed. Please contact our team member to remove this user's access to SpendBrain.",
        "allowedDomains": "E-mail domains associated with your organization: {{domains}}"
      },
      "validation": {
        "invalidDomain": "You can invite only users with e-mail domains associated with your organization: {{domains}}",
        "invalidEmail": "One or more provided email addresses are invalid",
        "alreadyInvited": "Some of the people were already invited but you can resend the invitation e-mail"
      },
      "resendInvitation": {
        "confirmation": {
          "title": "Resending invitation email to share access to SpendBrain",
          "description": "{{name}} has already received an invitation e-mail. You can resend it."
        },
        "successMessage": "Invitation email has been resent successfully",
        "errorMessage": "Failed to resend invitation email. Please try again later."
      },
      "removeAccess": {
        "confirmation": {
          "title": "Remove access to SpendBrain",
          "description": "{{name}} will immediately lose access to SpendBrain if you continue"
        },
        "successMessage": "You've successfully removed access for {{name}}",
        "errorMessage": "Failed to remove access for {{name}}. Please try again later."
      },
      "shareAccess": {
        "successMessage": {
          "message": "Sharing access successful",
          "description_other": "You've successfully shared access to SpendBrain with {{count}} people",
          "description_one": "You've successfully shared access to SpendBrain with {{count}} person"
        },
        "partialSuccessMessage": {
          "message": "Sharing access partially successful",
          "description_other": "You've successfully shared access to SpendBrain with {{count}} people, but failed to share with: {{emails}}",
          "description_one": "You've successfully shared access to SpendBrain with {{count}} person, but failed to share with: {{emails}}"
        },
        "errorMessage": {
          "message": "Sharing access failed",
          "description": "Failed to share access to SpendBrain. Please try again later."
        }
      }
    },
    "feedbackDialog": {
      "title": "Give us feedback",
      "subtitle": "We would greatly appreciate it if you could take a moment to leave us your feedback. Your thoughts and suggestions help us improve and provide you with the best possible experience. Thank you for your time and support!",
      "fields": {
        "gettingStartedEase": "How easy was it for you to get started with SpendBrain?",
        "navigationEase": "How easy is it to navigate and use SpendBrain?",
        "feedbackDescription": {
          "label": "What do you think we could do to improve the overall user experience in SpendBrain?",
          "placeholder": "Tell us more..."
        }
      },
      "successMessage": {
        "message": "Thank you for your feedback!",
        "description": "Your feedback helps us improve and provide you with the best possible experience."
      },
      "errorMessage": {
        "message": "Failed to send feedback",
        "description": "Failed to send feedback. Please try again later."
      }
    },
    "fileUpload": {
      "addFiles": "Add files",
      "maxSize": "(max {{size}})",
      "supportedFormats": "Supported formats: {{formats}}",
      "browse": "Browse",
      "errorMessage": "File is too large",
      "title": "Upload file",
      "description": "Supported format: {{supportedFormats}}",
      "maxSizeInfo": "Maximum file size: {{size}}",
      "buttonSubmit": "Browse",
      "uploadDocuments": "Upload documents",
      "uploadedDocuments": "Uploaded documents",
      "alreadyUploaded": "Already uploaded",
      "maxFilesError": "Maximum {{maxFiles}} files allowed.",
      "removeFileToProceedMessage": "Remove this file to proceed",
      "duplicateDialog": {
        "title": "File already exists",
        "description": "The following file(s) already exist. Do you want to replace them?",
        "cancel": "Keep existing",
        "filesCount_one": "{{count}} file:",
        "filesCount_other": "{{count}} files:"
      },
      "fileActions": {
        "addToDocumentRepository": "Add to Document Repository",
        "removeFromDocumentRepository": "Remove from Document Repository",
        "addToDocsRepoDisabledTooltip": "You must first select an organization in order to add a file to the Document Repository",
        "shouldAddToDocumentRepositoryFlag": "Documents Repository",
        "deleteDocument": "Delete document"
      },
      "errors": {
        "fileTooLarge": "File is too large.",
        "maxFiles": "You can upload up to {{max}} files.",
        "maxSize": "Total file size must not exceed {{max}} MB.",
        "dropzone": {
          "file-invalid-type": "Wrong file extension provided.",
          "file-too-large": "File is too large.",
          "file-too-small": "File is too small.",
          "too-many-files": "Too many files."
        }
      }
    },
    "comments": {
      "title": "Comments",
      "emptyListMessage": "No comments to display in this {{context}}, add one below."
    },
    "groupingAndSorting": {
      "label": "Grouping & sorting",
      "groupLabel": "Grouping",
      "grouping": "Group by:",
      "sorting": "Sort by",
      "inside": "(inside):",
      "apply": "Apply"
    },
    "newVersionDialog": {
      "title": "New version available",
      "subtitle": "A new version of SpendBrain is available. Please refresh the page to get the latest updates.",
      "submit": "Refresh"
    },
    "tableTextInput": {
      "addValue": "Add value"
    },
    "tableDatePicker": {
      "addValue": "Select date"
    },
    "pdfPreview": {
      "previous": "Previous",
      "next": "Next",
      "page": "Page {{page}}/{{totalPages}}",
      "error": {
        "title": "Unable to load PDF",
        "message": "There was an error loading the PDF file",
        "error": "PDF Error: {{error}}"
      }
    },
    "documentLoader": {
      "loading": "Loading document..."
    },
    "form": {
      "vectorTicketWarning": {
        "title": "Ticket creation unavailable",
        "message": "Ticket creation is temporarily unavailable for Vector organizations. Please select a different organization or contact support for assistance."
      },
      "vectorUnsupportedFieldsInfoBar": {
        "message": "Limited support for Vector organizations. Some ticket fields are not available for Vector organizations and cannot be edited."
      },
      "organizationChangeDisabledWarning": {
        "title": "Organization change disabled",
        "message": "You must first remove all files from the Document Repository before changing the organization."
      },
      "contactField": {
        "searchPlaceholder": "Search contact",
        "placeholder": "Select contact",
        "contact": {
          "vendor": "Vendor",
          "client": "Client",
          "internalEmployees": "Internal Employees"
        }
      }
    },
    "tagDropdown": {
      "details": {
        "title": "Title",
        "phone": "Phone",
        "email": "Email",
        "type": "Type"
      }
    },
    "taskList": {
      "createdByPerson": "Created by",
      "ownerAndAssigned": "Assigned person/owner",
      "assignedPerson": "Assigned person",
      "info": {
        "category": "Category",
        "reference": "Refference",
        "completedAt": "Completed at"
      },
      "statsPanel": {
        "all": "All",
        "total": "Total",
        "upcoming": "Upcoming",
        "overdue": "Overdue",
        "dueToday": "Due Today",
        "past": "Past"
      },
      "defaultReferenceName": "Reference",
      "restoreTaskNotAllowedTooltip": "This task is archived - open task details to restore this task.",
      "blockedTaskTooltip": "You must close all subtasks before closing the main task.",
      "isNotAssignedToMeTooltip": "You can't complete this task because it is not assigned to you.",
      "completedDate": "Completed date:",
      "deleteTask": "Delete",
      "restoreTask": "Restore",
      "addComment": "Add comment",
      "sendReminder": "Send reminder",
      "changeHistory": "Change history",
      "noChangeHistory": "There is no change history for this task yet.",
      "commentDialog": {
        "title": "Add comment",
        "comment": "Comment",
        "placeholder": "Write a comment...",
        "submitText": "Save comment"
      },
      "reminderDialog": {
        "title": "Send reminder",
        "priority": "Priority",
        "message": "Message",
        "placeholder": "Write a message...",
        "submitText": "Send"
      },
      "noCategory": "Other",
      "emptyListMessage": "It looks like you don't have any tasks in this section yet.",
      "sections": {
        "overdue": "Overdue",
        "today": "Today",
        "upcoming": "Upcoming",
        "recentlyClosed": "Recently Closed",
        "archived": "Archived"
      },
      "deleteConfirmation": "Are you sure you want to delete this task?",
      "deleteConfirmationDescription": "This action cannot be undone.",
      "title": "Goal Tracking",
      "filters": {
        "all": "All",
        "active": "Active",
        "completed": "Completed"
      },
      "activities": "Activities",
      "recents": "Recents",
      "buttonOption": {
        "addSubtask": "Add subtask",
        "completeAndAddNextStep": "Complete & Add Next Step",
        "duplicate": "Duplicate",
        "edit": "Edit",
        "details": "Details",
        "addComment": "Add comment"
      },
      "subTaskList": {
        "title": "Subtasks ({{subtaskCount}}):",
        "emptyListMessage": "There are no subtasks yet."
      },
      "closeUncompleteTaskDialog": {
        "title": "Complete task with open subtasks?",
        "description": "This task has unfinished subtasks. Are you sure you want to complete?"
      },
      "taskCompletedNotification": {
        "title": "Task completed successfully",
        "description": "Do you want to create a Next Step task?",
        "createNextStep": "Create Next Step task"
      },
      "followUp": {
        "previousTask": "Previous:",
        "nextTask": "Next:"
      },
      "logTime": {
        "submit": "Log time",
        "EstimatedTime": "Estimated time",
        "TimeLogged": "Time logged"
      },
      "organization": "Organization"
    },
    "phoneLink": {
      "zoomCall": "Call via Zoom",
      "sms": "Send SMS via Zoom",
      "call": "Call via phone"
    },
    "taskHistory": {
      "subtaskDeleted": "Subtask was deleted",
      "subtaskDeletedName": "Deleted subtask: \"{{subtaskName}}\"",
      "dueDateChanged": "Due date was changed from {{previousDate}} to {{newDate}}",
      "noDueDate": "no due date",
      "referenceLinkAdded": "Reference link was added",
      "referenceNameChanged": "Reference name was changed to \"{{referenceName}}\"",
      "categoryChanged": "Category was changed from {{previousValue}} to {{newValue}}",
      "statusChanged": "Status was changed from {{previousValue}} to {{newValue}}",
      "assigneeChanged": "Assignee was changed from {{previousValue}} to {{newValue}}",
      "estimatedTimeChanged": "Estimated time was changed from {{previousValue}} to {{newValue}} minutes",
      "timeLoggedChanged": "Time logged was changed from {{previousValue}} to {{newValue}} minutes",
      "seenAtChanged": "Task was seen at {{seenAt}}",
      "noSeenDate": "never seen",
      "markedAsSeen": "Task was marked as seen",
      "markedAsUnseen": "Task was marked as unseen",
      "tagAddedName": "Added tag: \"{{tagName}}\"",
      "tagRemovedName": "Removed tag: \"{{tagName}}\"",
      "commentAdded": "Comment was added",
      "commentAddedName": "Added comment: \"{{commentText}}\"",
      "commentDeleted": "Comment was deleted",
      "commentDeletedName": "Deleted comment: \"{{commentText}}\""
    },
    "subtaskHistory": {
      "noChangeHistory": "There is no change history for this subtask yet.",
      "markedAsCompleted": "Subtask was marked as completed",
      "markedAsIncomplete": "Subtask was marked as incomplete",
      "createdByChanged": "Created by {{userName}}",
      "updatedByChanged": "Updated by {{userName}}",
      "taskChanged": "Parent task was changed"
    },
    "changelog": {
      "entityCreated": "{{entityName}} was created",
      "entityUpdated": "{{entityName}} was updated",
      "titleChanged": "Title was changed from \"{{oldTitle}}\" to \"{{newTitle}}\"",
      "descriptionChanged": "Description was changed from \"{{oldDescription}}\" to \"{{newDescription}}\"",
      "priorityChanged": "Priority was changed from {{oldPriority}} to {{newPriority}}",
      "genericChanged": "{{fieldLabel}} was changed from \"{{oldValue}}\" to \"{{newValue}}\"",
      "changesWereMade": "{{changeCount}} changes were made:",
      "createdBy": "Created by:",
      "fieldChanged": "{{fieldLabel}} changed",
      "multipleFieldsChanged": "{{fieldCount}} fields changed",
      "priority": {
        "low": "Low",
        "medium": "Medium",
        "high": "High"
      },
      "entities": {
        "task": "Task",
        "subtask": "Subtask"
      },
      "fields": {
        "title": "Title",
        "description": "Description",
        "priority": "Priority",
        "status": "Status",
        "dueDate": "Due date",
        "category": "Category",
        "assignee": "Assignee",
        "reference": "Reference",
        "estimatedTime": "Estimated time",
        "timeLogged": "Time logged",
        "tags": "Tags"
      }
    },
    "tags": {
      "dueDate": {
        "today": "Today",
        "tomorrow": "Tomorrow",
        "overdue": "Overdue"
      },
      "recurring": "Recurring",
      "completed": "Completed",
      "recurringType": {
        "day_one": "Every day",
        "day_other": "Every {{count}} days",
        "week_one": "Every week",
        "week_other": "Every {{count}} weeks",
        "month_one": "Every month",
        "month_other": "Every {{count}} months"
      },
      "action": "Action"
    },
    "normalTaskListUpperSection": {
      "addTask": "Add Task"
    },
    "taskFormDialog": {
      "new": "New Task",
      "edit": "Edit Task"
    },
    "taskDetails": {
      "editTask": "Edit task",
      "completeTask": "Complete",
      "createNextStep": "Complete & Add Next Step",
      "cannotEditTooltip": "You don't have permission to edit this task.",
      "fields": {
        "completedSubtasks": "Completed subtasks",
        "viewTicket": "View ticket"
      },
      "status": {
        "new": "New",
        "completed": "Completed"
      },
      "tabs": {
        "taskDetails": "Task Details",
        "subtasks": "Subtasks ({{count}})",
        "comments": "Comments ({{count}})",
        "activityLog": "Activity Log ({{count}})"
      },
      "subtasks": {
        "addSubtask": "Add Subtask",
        "emptyListMessage": "There are no subtasks yet.",
        "card": {
          "assignee": "Assignee",
          "dueDate": "Due date",
          "edit": "Edit subtask"
        },
        "newSubtask": {
          "heading": "New Subtask",
          "markAsComplete": "Mark as Complete",
          "createSubtask": "Create Subtask"
        },
        "editSubtask": {
          "heading": "Edit Subtask",
          "saveChanges": "Save Changes"
        }
      },
      "comments": {
        "newComment": "New comment",
        "yourComment": "Your comment",
        "placeholder": "Write a comment...",
        "emptyList": "There are no comments yet."
      },
      "activityLog": {
        "empty": "There is no activity yet.",
        "fields": {
          "title": "Title",
          "description": "Description",
          "priorityLevel": "Priority",
          "referenceLink": "Reference link",
          "referenceName": "Reference name",
          "category": "Type",
          "assignee": "Assignee",
          "organization": "Organization",
          "vendor": "Vendor",
          "completed": "Completed",
          "completedAt": "Completed at",
          "deadline": "Due date",
          "seenAt": "Seen at",
          "seen": "Seen",
          "followUpTaskParent": "Follow-up task",
          "recurringTask": "Recurring task",
          "subauditId": "Sub-audit",
          "timeLogged": "Time logged",
          "estimatedTime": "Estimated time",
          "hiddenBefore": "Hidden before",
          "project": "Project",
          "ticket": "Ticket",
          "createdBy": "Created by",
          "updatedBy": "Updated by",
          "deletedAt": "Deleted at",
          "tagsCreated": "Tags added",
          "tagsDeleted": "Tags removed",
          "subtask": "Subtask",
          "comment": "Comment"
        },
        "actions": {
          "fieldChanged": "{{fieldLabel}} was changed from <strong>{{oldValue}}</strong> to <strong>{{newValue}}</strong>",
          "fieldToggledOn": "{{fieldLabel}} was <strong>turned on</strong>",
          "fieldToggledOff": "{{fieldLabel}} was <strong>turned off</strong>",
          "fieldToggledOnWithName": "{{itemType}} <strong>{{name}}</strong>: {{fieldLabel}} was <strong>turned on</strong>",
          "fieldToggledOffWithName": "{{itemType}} <strong>{{name}}</strong>: {{fieldLabel}} was <strong>turned off</strong>",
          "taskCreated": "Task was <strong>created</strong>",
          "relatedItemAdded": "{{itemType}} <strong>{{name}}</strong> was added",
          "relatedItemDeleted": "{{itemType}} <strong>{{name}}</strong> was deleted"
        }
      }
    },
    "taskForm": {
      "getReference": "Get reference",
      "autocompletePlaceholder": "Search person...",
      "teamTaskEditBanner": {
        "title": "Editing team task",
        "description": "Changes you make here will also update this task in the organization layout."
      },
      "fields": {
        "details": "Details",
        "type": "Type",
        "title": {
          "label": "Title",
          "placeholder": "Title"
        },
        "description": {
          "label": "Description",
          "placeholder": "Description"
        },
        "priority": {
          "label": "Priority"
        },
        "category": {
          "label": "Type"
        },
        "status": "Status",
        "completed": {
          "label": "Mark as completed"
        },
        "tag": {
          "label": "Tag",
          "addTag": "Create new tag",
          "editTag": "Edit tag",
          "name": "Name",
          "color": "Color",
          "searchPlaceholder": "Search tag...",
          "editTags": "Edit tags",
          "deleteSelectedTags": "Delete selected tags ({{selectedCount}})",
          "editTagsDialogTitle": "Edit tags",
          "delete": "Delete tag",
          "contact": {
            "title": "Contact",
            "internalEmployees": "Internal Employees",
            "vendor": "Vendor Contacts",
            "client": "Client Contacts"
          },
          "predefined": "Predefined Tags",
          "placeholder": "Not selected",
          "selectedCount": "{{count}} selected"
        },
        "reference": {
          "label": "Reference"
        },
        "referenceName": {
          "placeholder": "Reference Name"
        },
        "referenceLink": {
          "placeholder": "Reference Link"
        },
        "organization": {
          "label": "Organization"
        },
        "vendor": {
          "label": "Vendor"
        },
        "ticket": {
          "label": "Related Ticket",
          "searchPlaceholder": "Search ticket number..."
        },
        "deadline": {
          "label": "Due Date"
        },
        "assignedTo": {
          "label": "Assigned person"
        },
        "author": {
          "label": "Author"
        },
        "estimatedTime": {
          "label": "Estimated Time",
          "placeholder": "0 min"
        }
      }
    }
  },
  "entities": {
    "project": "Project",
    "ticket": "Ticket",
    "actionItem": "Action item",
    "task": "Task",
    "taskComment": "Task comment",
    "subtask": "Subtask",
    "recurringTask": "Recurring task",
    "location": "Location",
    "vendor": "Vendor",
    "audit": "Audit",
    "documents": "documents",
    "invoices": "invoices",
    "meeting": "Meeting",
    "note": "Note"
  },
  "views": {
    "taskListView": {
      "create": "Add Task"
    }
  },
  "enums": {
    "categories": {
      "Vendor_Call": "Vendor Call",
      "Client_Call": "Client Call",
      "Internal_outreach": "Internal outreach",
      "Vendor_email": "Vendor email",
      "Client_email": "Client email",
      "Data_analysis": "Data analysis",
      "Report_build": "Report build",
      "Data_gathering": "Data gathering",
      "Invoice_Collection": "Invoice collection",
      "Research": "Research",
      "Proactive_Client_Outreach": "Proactive Client Outreach",
      "Other": "Other"
    },
    "locationStatus": {
      "active": "Active",
      "monitored": "Monitored",
      "sold": "Sold",
      "closed": "Closed",
      "underConstruction": "Under Construction",
      "notActive": "Not Active"
    },
    "documentFieldStatus": {
      "complete": "Complete",
      "missingFields": "Missing fields",
      "uploadInvoices": "Upload invoices",
      "naRequested": "N/A (requested)",
      "notApplicable": "Not applicable"
    },
    "projectStatus": {
      "unassigned": "Unassigned",
      "unstarted": "Unstarted",
      "in-progress": "In Progress",
      "on-hold": "On Hold",
      "view-only": "View Only",
      "in-review": "In Review",
      "escalated": "Escalated",
      "completed": "Completed"
    },
    "vendorStatus": {
      "active": "Active",
      "inactive": "Inactive",
      "on-hold": "On Hold"
    },
    "Priority": {
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "ProjectStatus": {
      "ALL": "All stages",
      "MOBILIZATION": "Mobilization",
      "SPEND_ESTIMATED": "Spend estimated",
      "NEGOTIATIONS": "Negotiations",
      "INITIAL_VALIDATION": "Initial validation",
      "MONITORING_SAVINGS": "Monitoring Savings"
    },
    "Difficulty": {
      "VeryEasy": "Very easy",
      "Easy": "Easy",
      "Neutral": "Neutral",
      "Hard": "Hard",
      "VeryHard": "Very hard"
    },
    "SpendAreaStage": {
      "MONITORING_SAVINGS": "Monitoring savings",
      "INITIAL_VALIDATION": "Initial validation",
      "SPEND_ESTIMATED": "Spend estimated",
      "MOBILIZATION": "Mobilization",
      "NEGOTIATIONS_VENDOR": "Negotiations – Vendor",
      "NEGOTIATIONS_CLIENT": "Negotiations – Client"
    }
  },
  "validation": {
    "messageCantBeLongerThan": "Your message cannot be longer than {{max}} characters",
    "required": "This field is required",
    "invalidPhoneNumber": "Please enter a valid phone number",
    "invalidUrl": "Please enter a valid URL"
  },
  "aiServiceModal": {
    "askSpendBrainContact": "Contact our team member",
    "askSpendBrainModalTitle": "Ask SpendBrain AI Assistant",
    "askSpendBrainModalDescription": "You haven't activated SpendBrain AI Assistant yet! Activate and get immediate insights about your spend!",
    "spendbrainActivationSubject": "Ask SpendBrain AI Assistant Activation Request",
    "learnMore": "Learn more"
  },
  "phoneNumberModal": {
    "title": "Let's stay in touch",
    "description": "We'd like to inform you about important meetings and upcoming events that will help you to stay on top of things. It's optional, but highly recommended for a smoother experience!",
    "placeholder": "Type phone number",
    "searchCountry": "Search country...",
    "noCountryFound": "No country found.",
    "continue": "Continue",
    "dontAskAgain": "Don't ask again",
    "successMessage": {
      "message": "Thank you!",
      "description": "Your contact information has been saved successfully."
    },
    "errorMessage": {
      "message": "Failed to save contact information",
      "description": "Something went wrong. Please try again later."
    }
  },
  "errors": {
    "modules": {
      "dashboard": "dashboard",
      "documents": "documents repository"
    },
    "redirect": "Go back to {{module}}",
    "pageNotFound": {
      "title": "Opps! Page not found",
      "description": "The requested URL was not found on this server, that's all we know!"
    },
    "validation": {
      "cantBeLonger": "{{fieldLabel}} can't be longer than {{maxLength}} characters",
      "required": "{{fieldLabel}} is required",
      "integer": "{{fieldLabel}} must be an integer",
      "positiveNumber": "{{fieldLabel}} must be a positive number",
      "invalidDate": "The provided date is invalid",
      "invalidEmails": "Please enter valid emails"
    },
    "genericErrors": {
      "title": "Action failed",
      "createFailed": "An error occurred while creating the {{entityName}}",
      "editFailed": "An error occurred while editing the {{entityName}}",
      "deleteFailed": "An error occurred while deleting the {{entityName}}"
    },
    "client": {
      "DUPLICATED_TEAM_NAME": {
        "message": "Duplicated team name",
        "description": "Team with this name already exists."
      },
      "TASK_CREATION_FAILED": {
        "message": "Task creation failed",
        "description": "An error occurred while creating the task."
      },
      "TASK_EDITION_FAILED": {
        "message": "Task editing failed",
        "description": "An error occurred while editing the task."
      },
      "TASK_LOG_TIME_FAILED": {
        "message": "Task log time failed",
        "description": "An error occurred while logging the time for the task."
      },
      "SUBTASK_CREATION_FAILED": {
        "message": "Subtask creation failed",
        "description": "An error occurred while creating the subtask."
      },
      "SUBTASK_EDITION_FAILED": {
        "message": "Subtask editing failed",
        "description": "An error occurred while editing the subtask."
      },
      "SOMETHING_WENT_WRONG": {
        "message": "Something went wrong",
        "description": "Please try again later."
      },
      "LOGIN_ERROR": {
        "message": "Login failed",
        "description": "An error occurred while logging in."
      },
      "TASK_DELETION_FAILED": {
        "message": "Task deletion failed",
        "description": "An error occurred while deleting the task."
      },
      "TASK_RESTORATION_FAILED": {
        "message": "Task restoration failed",
        "description": "An error occurred while restoring the task."
      },
      "SUBTASK_DELETION_FAILED": {
        "message": "Subtask deletion failed",
        "description": "An error occurred while deleting the subtask."
      },
      "RECURRING_TASK_CREATION_FAILED": {
        "message": "Recurring task creation failed",
        "description": "An error occurred while creating the recurring task."
      },
      "RECURRING_TASK_EDITION_FAILED": {
        "message": "Recurring task editing failed",
        "description": "An error occurred while editing the recurring task."
      },
      "RECURRING_TASK_DELETION_FAILED": {
        "message": "Recurring task deletion failed",
        "description": "An error occurred while deleting the recurring task."
      },
      "fileAlreadyUploaded": "File with that name and size within given organization already exists",
      "TAG_ALREADY_EXISTS": {
        "message": "Tag name already exists",
        "description": "Choose a different name – a tag with this label is already exists."
      },

      "TAG_DELETION_FAILED": {
        "message": "Tag deletion failed",
        "description": "An error occurred while deleting the tag."
      },
      "TEAM_CREATION_FAILED": {
        "message": "Team creation failed",
        "description": "An error occurred while creating the team."
      },
      "TEAM_EDIT_FAILED": {
        "message": "Team edit failed",
        "description": "An error occurred while editing the team."
      },
      "TEAM_MEMBERS_UPDATE_FAILED": {
        "message": "Team members update failed",
        "description": "An error occurred while updating the team members."
      },
      "PIN_ORGANIZATION_FAILED": {
        "message": "Pin organization failed",
        "description": "An error occurred while pinning the organization to the dashboard."
      },
      "UNPIN_ORGANIZATION_FAILED": {
        "message": "Unpin organization failed",
        "description": "An error occurred while unpinning the organization from the dashboard."
      },
      "SUB_AUDIT_CREATION_FAILED": {
        "message": "Sub-audit creation failed",
        "description": "An error occurred while creating the sub-audit."
      },
      "SUB_AUDIT_EDITION_FAILED": {
        "message": "Sub-audit editing failed",
        "description": "An error occurred while editing the sub-audit."
      },
      "SUB_AUDIT_COMMENT_CREATION_FAILED": {
        "message": "Sub-audit comment creation failed",
        "description": "An error occurred while creating the comment for the sub-audit."
      },
      "SUB_AUDIT_COMMENT_EDITION_FAILED": {
        "message": "Sub-audit comment editing failed",
        "description": "An error occurred while editing the comment for the sub-audit."
      },
      "SUB_AUDIT_COMMENT_DELETION_FAILED": {
        "message": "Sub-audit comment deletion failed",
        "description": "An error occurred while deleting the comment for the sub-audit."
      },
      "TICKET_CREATION_FAILED": {
        "message": "Ticket creation failed",
        "description": "An error occurred while creating the ticket."
      },
      "TICKET_EDITION_FAILED": {
        "message": "Ticket update failed",
        "description": "An error occurred while updating the ticket."
      },
      "TICKET_FILE_MOVE_FAILED": {
        "message": "Ticket file move failed",
        "description": "An error occurred while moving the file to the document repository."
      },
      "TICKET_FILE_REMOVE_FAILED": {
        "message": "Ticket file remove failed",
        "description": "An error occurred while removing the file from the document repository."
      },
      "TICKET_FILE_DELETE_FAILED": {
        "message": "Ticket file delete failed",
        "description": "An error occurred while deleting the file from the ticket."
      }
    },
    "server": {
      "BAD_REQUEST": {
        "message": "Validation error",
        "description": "The request could not be processed due to validation errors."
      },
      "TICKET_FILE_DUPLICATE": {
        "message": "Duplicate file",
        "description": "File already exists in this ticket."
      },
      "UNAUTHORIZED": {
        "message": "Unauthorized",
        "description": "You are not authorized to perform this action."
      },
      "FORBIDDEN": {
        "message": "Forbidden",
        "description": "You are not allowed to perform this action."
      },
      "NOT_FOUND": {
        "message": "Not found",
        "description": "The requested resource was not found."
      },
      "UNPROCESSABLE_ENTITY": {
        "message": "Unprocessable entity",
        "description": "The request was well-formed but could not be processed due to semantic errors."
      },
      "INTERNAL_SERVER_ERROR": {
        "message": "Internal server error",
        "description": "An error occurred on the server."
      },
      "SERVICE_UNAVAILABLE": {
        "message": "Service unavailable",
        "description": "The server is currently unavailable."
      },
      "GATEWAY_TIMEOUT": {
        "message": "Gateway timeout",
        "description": "The server is currently unavailable."
      }
    }
  },
  "successMessages": {
    "client": {
      "TAG_CREATION_SUCCESS": {
        "message": "Tag creation successful",
        "description": "Tag has been created successfully"
      },
      "TAG_DELETION_SUCCESS": {
        "message": "Tag deletion successful",
        "description": "The tag has been deleted successfully"
      }
    }
  },
  "header": "Workflow",
  "header2": "Manager",
  "navigation": {
    "dashboard": "Dashboard",
    "archive": "Archived",
    "import": "Upload tasks",
    "recurring": "Recurring tasks",
    "organization": "Organizations",
    "teams": "Teams",
    "assignedToOthers": "Assigned to others",
    "templates": "Templates",
    "tickets": "Tickets",
    "allActionItems": "All action items",
    "notifications": "Notifications",
    "settings": "Settings"
  },
  "logout": {
    "title": "Log out",
    "description": "Are you sure you want to log out from Sidecar?",
    "logoutButton": "Logout"
  },
  "searchPanel": {
    "title": "Search result",
    "labels": {
      "tasks": "Tasks",
      "tickets": "Tickets",
      "organizations": "Organizations",
      "members": "Members",
      "SubAudits": "Sub Audits"
    }
  },
  "fields": {
    "recurringTask": "Recurring tasks",
    "task": "Task",
    "title": "Title",
    "description": "Description",
    "category": "Category",
    "priority": "Priority",
    "deadline": "Deadline",
    "completed": "Completed",
    "referenceName": "Reference name",
    "referenceUrl": "Reference link",
    "comment": "Comment",
    "reminderMessage": "Message",
    "inviteTeamMember": "At least one user",
    "teamName": "Team name",
    "time": "Time",
    "estimatedTime": "Estimated time",
    "missingField": "*missing field"
  },
  "deleteDialog": {
    "baseTitle": "This action cannot be undone.",
    "baseDescription": "Are you sure you want to delete this {{entityName}}?"
  },
  "internalPortal": {
    "workInProgressPopup": {
      "title": "Work in progress",
      "description": "This product is currently under active development. Some features may not work as expected and functionality may change as improvements are released.",
      "dismiss": "Don't remind me again"
    }
  },
  "termsOfServiceModal": {
    "title": "Terms of Service",
    "description": "Please accept the Terms of Service.",
    "accept": "I Agree",
    "signatory": "Signatory"
  }
}
